module.exports = __webpack_public_path__ + "cbc1054504e15571bc38756094256810.svg";